module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "front"
  }, [_vm._v("Q"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UESTION")]), _c('br'), _vm._v("(from the editors of "), _c('i', [_vm._v("Education News")]), _vm._v(", New York City)")]), _vm._v(" "), _c('p', {
    staticClass: "front1"
  }, [_vm._v("If America’s schools were to take one giant step forward this year toward a better tomorrow, what should it be?")]), _vm._v(" "), _c('p', {
    staticClass: "front2"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSWER")]), _c('br'), _vm._v("(from John Holt)")]), _vm._v(" "), _c('p', {
    staticClass: "front1"
  }, [_vm._v("It would be to let every child be the planner, director, and assessor of his own education, to allow and encourage him, with the inspiration and guidance of more experienced and expert people, and as much help as he asked for, to decide what he is to learn, when he is to learn it. How he is to learn it, and how well he is learning it. It would be to make our schools, instead of what they are, which is jails for children, into a resource for free and independent learning, which everyone in the community, of whatever age, could use as much or as little as he wanted.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc8bbfb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front.vue
// module id = 75
// module chunks = 0